// extracted by mini-css-extract-plugin
module.exports =  {"clear-search":"searchField__clear-search"};